import React from 'react';

// DEPENDENCIES
import { useFormikContext } from 'formik';
import { compose } from 'redux';

// GLOBAL FUNCTIONS
import { controlName } from 'functions.js';

// HELPERS
import { uploadContext } from 'core/form/control/types/upload/helpers/uploadContext';
import { uploadFormik } from 'core/form/control/types/upload/helpers/uploadFormik';

// COMPONENTS
const DecoratedAttachment = compose(
  uploadContext,
  uploadFormik
)(({ children }) => children);

const handleUploadMeta = data => ({
  fileName: data.attachment_filename,
  uploadedBy: data.updated_by || data.created_by,
  uploadedOn: data.date_created
});

// MAIN COMPONENT
export const useUploadHelpers = (item, index) => {

  // FORMIK
  const formikBag = useFormikContext();

  // RENDER
  return (
    <DecoratedAttachment
      name={controlName('aryDownpaymentAttachment', 'aryDownPayment', index)}
      uploadMeta={handleUploadMeta}
      multiple
      form={formikBag}
    >
      {item}
    </DecoratedAttachment>
  )
}
